<template>
    <div>
        <b-button
            v-if="checkRight('ProductCreate')"
            size="sm"
            @click="createItem()"
            class="bgc_aux_normal float-right"
            ><font-awesome-icon icon="edit" size="1x" />
        </b-button>
        <b-table
            striped
            responsive
            :fields="visibleFields"
            :items="displaylist"
            ref="selectableTable"
            @row-clicked="selectItem"
        >
            <template v-slot:cell(actions)="row">
                <b-button
                    v-if="checkRight('ProductUpdate')"
                    size="sm"
                    @click="editItem(row.item)"
                    class="bgc_aux_warning"
                    ><font-awesome-icon icon="edit" size="1x" />
                </b-button>
                <b-button
                    v-if="checkRight('ProductUpdate')"
                    size="sm"
                    @click="verwijderItem(row.item)"
                    class="bgc_aux_alarm"
                    ><font-awesome-icon icon="trash-alt" size="1x" />
                </b-button>
            </template>
        </b-table>
        <b-modal
            id="modal-item"
            size="xl"
            ref="modal"
            :title="formtitle"
            :visible="visible"
            @hide="reset"
            @ok="handleOk"
        >
            <b-card @submit.stop.prevent="handleSubmit">
                <b-alert
                    v-model="showDismissibleAlert"
                    variant="danger"
                    dismissible
                >
                    {{ alertText }}
                </b-alert>

                <b-form-input v-model="voorItem" readonly></b-form-input>

                <b-input-group
                    :prepend="
                        $t('com_voor', {
                            ns: 'common'
                        })
                    "
                >
                    <b-form-select
                        v-if="!isUpdate"
                        v-model="localSelected"
                        :options="localList"
                        :disabled="isUpdate"
                    >
                        <template #first>
                            <b-form-select-option value=""
                                >--
                                {{
                                    $t('com_selecteer', {
                                        ns: 'common'
                                    })
                                }}
                                --</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                    <b-form-input
                        v-else
                        v-model="updateNaam"
                        readonly
                    ></b-form-input>
                </b-input-group>
                <b-input-group
                    :prepend="
                        $t('com_reference', {
                            ns: 'common'
                        })
                    "
                >
                    <b-form-input v-model="localReference"></b-form-input>
                </b-input-group>
            </b-card>
        </b-modal>
    </div>
</template>

<script>
import { loadItem, loadList } from '@/models/DataHelper';
import Helper from '@/models/Helper';
import { Permission } from '../../models/Permissions';
import PRODCAT_ENUM from '@/models/ProductCategorie';
export default {
    name: 'CompanyProductValues',
    data: function () {
        return {
            showDismissibleAlert: false,
            alertText: '',
            displaylist: [],
            productLijst: [],
            companyLijst: [],
            localSelected: '',
            localReference: '',
            updateNaam: '',
            visible: false,
            isUpdate: false,
            locItem: {},
            product: {},
            company: {}
        };
    },
    props: {
        companyID: {
            type: Number,
            default: -1
        },
        productID: {
            type: Number,
            default: -1
        }
    },
    computed: {
        formtitle() {
            const low = this.$t('com_reference', {
                ns: 'common'
            }).toLowerCase();
            return this.locItem.id < 0
                ? this.$t('com_makenew', {
                      ns: 'common',
                      val: low
                  })
                : this.$t('com_edit', {
                      ns: 'common',
                      val: low
                  });
        },
        voorItem() {
            return this.companyID > -1
                ? this.locItem.company
                : this.locItem.product;
        },
        localList() {
            const lijst =
                this.companyID > -1 ? this.productLijst : this.companyLijst;
            const lijstFiltered =
                this.companyID > -1
                    ? lijst.filter((item) => {
                          return !this.displaylist.some(
                              (x) => x.productID === item.value
                          );
                      })
                    : lijst.filter((item) => {
                          return !this.displaylist.some(
                              (x) => x.companyID === item.value
                          );
                      });
            return lijstFiltered;
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                {
                    key: 'company',
                    label: this.$t('com_company', { ns: 'common' }),
                    sortable: true,
                    visible: !(this.companyID > -1)
                },
                {
                    key: 'product',
                    label: this.$t('com_product', { ns: 'common' }),
                    sortable: true,
                    visible: !(this.productID > -1)
                },
                {
                    key: 'reference',
                    label: this.$t('com_reference', { ns: 'common' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        }
    },
    methods: {
        checkRight(recht) {
            const id = Permission.enum(recht);
            return this.$root.handleRight(id);
        },
        reset() {
            this.locItem = {};
            this.visible = false;
        },
        selectItem(item) {
            this.locItem = item;
        },
        createItem() {
            this.isUpdate = false;
            this.locItem = {
                companyID: this.companyID,
                productID: this.productID,
                company: this.companyID > -1 ? this.company.naam : '',
                product: this.productID > -1 ? this.product.naam : '',
                reference: ''
            };
            this.localReference = '';
            this.localSelected = -1;
            this.visible = true;
        },
        editItem(item) {
            this.locItem = item;
            this.isUpdate = true;
            this.updateNaam = this.companyID > -1 ? item.product : item.company;
            this.localSelected =
                this.companyID > -1 ? item.productID : item.companyID;
            this.localReference = item.reference;
            this.visible = true;
        },
        async handleOk() {
            // save locItem to database
            if (this.companyID > -1) {
                this.locItem.productID = this.localSelected;
            } else {
                this.locItem.companyID = this.localSelected;
            }
            const info = {
                companyID: this.locItem.companyID,
                productID: this.locItem.productID,
                reference: this.localReference
            };
            await loadItem('product/storeProductReference', info, this.$t);
            await this.refreshList();
            this.visible = false;
        },
        async verwijderItem(item) {
            const omschrijving = Helper.stringformat(
                '{0} {1}: {2}',
                item.company,
                item.product,
                item.reference
            );
            const message = this.$t(
                'com_delete',
                { ns: 'common' ,
                 val: omschrijving }
            );
            const doClose = await this.$root.showConfirmationBox(message);
            if (doClose === true) {
                const model = {
                    companyID: item.companyID,
                    productID: item.productID,
                    reference: item.reference
                };
                await loadItem(
                    'product/deleteProductReference',
                    model,
                    this.$t
                );
                this.refreshList();
            }
        },
        async refreshList() {
            const model = {
                companyID: this.companyID,
                productID: this.productID
            };
            this.displaylist = await loadItem(
                'product/loadProductReferences',
                model,
                this.$t
            );
        }
    },
    mounted() {},
    async created() {
        const model = {
            companyID: this.companyID,
            productID: this.productID
        };
        this.displaylist = await loadItem(
            'product/loadProductReferences',
            model,
            this.$t
        );
        if (this.productID > -1) {
            this.product = await loadItem(
                'product/loadProduct',
                { productID: this.productID },
                this.$t
            );
            this.companyLijst = await loadList(
                'components/getCompaniesComboLijst',
                'components/loadCompaniesComboLijst',
                null,
                false,
                this.$t
            );
        } else {
            this.company = await loadItem(
                'masterdata/loadCompany',
                { companyid: this.companyID },
                this.$t
            );
            this.productLijst = await loadList(
                'components/getProductsComboLijst',
                'components/loadProductsComboLijst',
                null,
                false,
                this.$t
            );
            // voorlopig alleen voor kaas, later uitbreiden naar andere productcategorieen
            const discrim = PRODCAT_ENUM.Kaas; //.toString();
            this.productLijst = this.productLijst.filter((c) => {
                return c.catid == discrim;
            });
        }
    }
};
</script>

<style scoped></style>
